export function formatPossibleEmptyValue(value) {
    if (value === null || typeof value === "undefined" || value === "") {
        return null;
    } else {
        return value;
    }
}
